module.exports = __webpack_public_path__ + "media/alone.696b355c.mp3";